import React from 'react'
import { BeamKonvaVisualization, CrossSectionKonva } from '../../components/BeamVisualizationKit'
import CrossSectionDetailsTable from '../../components/CrossSectionDetailsTable'
import { summarizeShearReinforcement } from '../../shearReinforcement'
import { SectionMaterialStrength, SMBeamModel } from '../../types'
import { useTranslation } from '@structura/i18n'

interface LoadVisualizationPanelProps
{
  model: SMBeamModel
  currentMaterial: string
  timberKind: 'glulam' | 'solid'
  sectionMaterialStrength: SectionMaterialStrength | null | undefined
}

const LoadVisualizationPanel: React.FC<LoadVisualizationPanelProps> = ({
  model,
  currentMaterial,
  timberKind,
  sectionMaterialStrength
}) => {
  const { t } = useTranslation()
  return (
  <div>
    <div className="card mb-3">
      <div className="card-header">
        <h5 className="card-title mb-0">{t('beam.loads.beamWithLoads')}</h5>
      </div>
      <div className="card-body">
        <BeamKonvaVisualization
          model={model}
          material={currentMaterial}
          width={600}
          height={300}
          storageKey="beamVisualization_loads"
        />
      </div>
    </div>

    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">{t('beam.geometry.crossSection')}</h5>
      </div>
      <div className="card-body">
        {model.crossSection ? (
          <div className="row">
            <div className="col-md-6">
              <CrossSectionKonva
                crossSection={model.crossSection}
                material={currentMaterial}
                timberKind={currentMaterial === 'timber' ? timberKind : undefined}
                width={400}
                height={300}
                {...(currentMaterial === 'concrete'
                  ? {
                      rebar: {
                        cover: ((model as any).rebarZones?.[0]?.cover) ?? 30,
                        layers: (((model as any).rebarZones?.[0]?.layers) ?? []).map((layer: any) => ({
                          z: layer.z,
                          diameter: layer.diameter,
                          count: layer.count
                        })),
                        stirrups: (model as any).rebarZones?.[0]?.stirrups
                          ? {
                              diameter: (model as any).rebarZones[0].stirrups.diameter,
                              spacing: (model as any).rebarZones[0].stirrups.spacing,
                              legs: (model as any).rebarZones[0].stirrups.legs
                            }
                          : undefined
                      }
                    }
                  : {})}
              />
            </div>
            <div className="col-md-6">
              <CrossSectionDetailsTable
                crossSection={model.crossSection}
                material={model.crossSection.material || currentMaterial}
                timberKind={(model.crossSection.material || currentMaterial) === 'timber' ? timberKind : undefined}
                materialStrength={sectionMaterialStrength ?? undefined}
                shearReinforcement={summarizeShearReinforcement(model)}
              />
            </div>
          </div>
        ) : (
          <div className="text-muted">{t('beam.geometry.loadingCrossSection')}</div>
        )}
      </div>
    </div>
  </div>
  )
}

export default LoadVisualizationPanel


